import React, { Component } from "react";
import toPairs from "lodash/toPairs";
import groupBy from "lodash/groupBy";
import { compose, withApollo, Query } from "react-apollo";
import { Box, Flex, FlexItem, Button, withTheme } from "mineral-ui";
import gql from "graphql-tag";
import { Elements, injectStripe } from "react-stripe-elements";
import { withSetStripePlan } from "../SetStripePlanMutation";
import Link from "../components/Link";
import { H2, H4, P } from "../components/html";
import { Plan, PlanName, PlanDescription } from "../components/billing";
import RefreshStripeMutation from "../RefreshStripeMutation";

const currency = null;

class GetAPlan extends React.Component {
  state = {
    selectedPlanId: null,
  };

  render() {
    const { data } = this.props;
    if (this.state.selectedPlanId) {
      const plan = data.allPlans.nodes.find(
        plan => plan.id === this.state.selectedPlanId
      );
      if (!plan) {
        return <div>Something went wrong</div>;
      }
      return (
        <div>
          <Link onClick={() => this.setState({ selectedPlanId: null })}>
            Cancel
          </Link>
          <H2>{plan.name}</H2>
        </div>
      );
    } else {
      return (
        <div>
          <p>Which plan do you want?</p>
          {toPairs(
            groupBy(
              data.allPlans.nodes.filter(n => n.id < 2000),
              plan => plan.slug.split("-")[0]
            )
          ).map(([planPrefix, nodes]) => (
            <Box key={planPrefix} marginTop="xl">
              <H4>
                <PlanName prefix={planPrefix} />:
              </H4>
              <P>
                <PlanDescription prefix={planPrefix} />
              </P>
              <Box paddingLeft="md">
                {nodes
                  .filter(
                    plan =>
                      !plan.currency || !currency || plan.currency === currency
                  )
                  .map(plan => (
                    <Flex width="100%" alignItems="center">
                      <FlexItem grow={1}>
                        <Plan key={plan.nodeId} plan={plan} />
                      </FlexItem>
                      <FlexItem width="9rem">
                        {plan.source === "patreon" ? (
                          <Button
                            fullWidth
                            element={Link}
                            href="https://patreon.com/benjie"
                          >
                            Visit Patreon
                          </Button>
                        ) : plan.source === "github" ? (
                          <Button
                            fullWidth
                            element={Link}
                            href="https://github.com/sponsors/benjie"
                          >
                            Visit GitHub
                          </Button>
                        ) : (
                          <Button
                            fullWidth
                            element={Link}
                            to={`/settings/change-plan?plan=${encodeURIComponent(
                              plan.id
                            )}`}
                          >
                            Select plan »
                          </Button>
                        )}
                      </FlexItem>
                    </Flex>
                  ))}
              </Box>
            </Box>
          ))}
        </div>
      );
    }
  }
}

class _Billing extends React.Component {
  state = {
    getPlan: false,
  };

  handleGetPlanClick = _e => {
    this.setState({ getPlan: !this.state.getPlan });
  };

  handleReinstatePlanClick = async () => {
    const { data } = this.props;
    const currentPlan = data.allPlans.nodes.find(plan => plan.viewerHasPlan);
    try {
      this.setState({ working: true });
      await this.props.setStripePlan({
        variables: {
          planId: currentPlan.id,
          cancel: false,
        },
      });
      this.props.client.resetStore();
      this.setState({ working: false });
    } catch (e) {
      this.setState({ working: false });
      window.alert(
        "Reinstating your subscription failed - please try again in a few minutes or get in touch on info@graphile.org"
      );
    }
  };

  handleCancelPlanClick = async () => {
    const { data } = this.props;
    const currentPlan = data.allPlans.nodes.find(plan => plan.viewerHasPlan);
    if (
      window.confirm(
        "Are you sure you want to cancel your subscription? Do send an email to info@graphile.org to let us know how we can improve."
      )
    ) {
      try {
        this.setState({ working: true });
        await this.props.setStripePlan({
          variables: {
            planId: currentPlan.id,
            cancel: true,
          },
        });
        this.props.client.resetStore();
        this.setState({ working: false });
      } catch (e) {
        this.setState({ working: false });
        window.alert(
          "Cancelling your subscription failed - please try again in a few minutes or get in touch on info@graphile.org"
        );
      }
    }
  };

  render() {
    const { data } = this.props;
    const currentPlan = data.allPlans.nodes.find(plan => plan.viewerHasPlan);
    if (currentPlan) {
      return (
        <div>
          <P>
            You're on the <PlanName prefix={currentPlan.slug.split("-")[0]} />{" "}
            plan. <Link to="/">Go home</Link> to view your license keys.
          </P>
          {currentPlan.viewerPlanExpires ? (
            <P small>
              Your subscription is due to expire {currentPlan.viewerPlanExpires}
              .
            </P>
          ) : null}
          {this.state.working ? (
            <P>Working...</P>
          ) : (
            <P>
              <Button
                element={Link}
                to={`/settings/change-plan?plan=${encodeURIComponent(
                  currentPlan.id
                )}`}
              >
                Change payment settings
              </Button>{" "}
              {!currentPlan.viewerPlanExpires ? (
                <Button variant="danger" onClick={this.handleCancelPlanClick}>
                  Cancel subscription
                </Button>
              ) : (
                <Button
                  variant="default"
                  onClick={this.handleReinstatePlanClick}
                >
                  Reinstate subscription
                </Button>
              )}
            </P>
          )}
        </div>
      );
    } else {
      return (
        <div>
          You don't have an active plan currently.
          <br />
          <br />
          {this.state.getPlan ? (
            <Button onClick={this.handleGetPlanClick}>Close</Button>
          ) : (
            <Button onClick={this.handleGetPlanClick}>Select plan</Button>
          )}
          <br />
          <br />
          <div style={this.state.getPlan ? {} : { display: "none" }}>
            <H4>Select a Plan</H4>
            <GetAPlan data={data} />
          </div>
        </div>
      );
    }
  }
}

const Billing = compose(withApollo, withSetStripePlan)(_Billing);

const InnerSCAButton = injectStripe(
  ({ stripe, secret, children, onComplete, onStart }) => {
    function handleCardPayment(e) {
      e.preventDefault();
      if (typeof onStart === "function") {
        onStart();
      }
      stripe.handleCardPayment(secret).then(result => {
        if (typeof onComplete === "function") {
          onComplete(null, result);
        }
      }, onComplete);
    }
    return <Button onClick={handleCardPayment}>{children}</Button>;
  }
);

const SCAButton = props => {
  return (
    <Elements>
      <InnerSCAButton {...props} />
    </Elements>
  );
};

class SettingsPage extends Component {
  state = {
    currency: "USD",
    thinking: false,
  };

  handleCurrencyChange = e => {
    this.setState({ currency: e.target.value || "USD" });
  };

  render() {
    const { data, theme } = this.props;
    return (
      <Box>
        <Box marginVertical="xl">
          <H2 align="center">Settings</H2>
        </Box>

        <Box marginTop="lg">
          <H4>Billing</H4>
          <RefreshStripeMutation>
            {refreshStripe => (
              <Query
                query={gql`
                  query CheckLatestInvoice {
                    viewer {
                      nodeId

                      latestPlan: userPlansByUserUuid(
                        first: 1
                        orderBy: CREATED_AT_DESC
                      ) {
                        nodes {
                          active
                          planId
                        }
                      }

                      latestStripeInvoice {
                        id
                        amountDue
                        amountPaid
                        currency
                        created
                        status
                        paymentIntentStatus
                        paymentIntentClientSecret
                      }
                    }
                  }
                `}
              >
                {innerData => {
                  const latestStripeInvoice =
                    innerData.data &&
                    innerData.data.viewer &&
                    innerData.data.viewer.latestStripeInvoice;
                  if (this.state.thinking) {
                    if (this.state.thinking === 2) {
                      return (
                        <P>
                          <em>... just another few moments, please ...</em>
                        </P>
                      );
                    }
                    return (
                      <P>
                        <em>... one moment please ...</em>
                      </P>
                    );
                  } else if (innerData.loading) {
                    return (
                      <P>
                        <em>Loading latest invoice details</em>
                      </P>
                    );
                  } else if (latestStripeInvoice) {
                    // eslint-disable-next-line no-inner-declarations
                    const amount = `${latestStripeInvoice.currency.toUpperCase()} ${(
                      latestStripeInvoice.amountDue / 100
                    ).toFixed(2)}`;
                    const date = new Date(
                      Date.parse(latestStripeInvoice.created)
                    ).toLocaleDateString();
                    const handleStart = () => {
                      this.setState({ thinking: true });
                    };
                    const handleComplete = () => {
                      this.setState({ thinking: 2 });
                      refreshStripe()
                        // Swallow errors (cannot rely on .finally yet)
                        .then(
                          () => {},
                          () => {}
                        )
                        .then(() => {
                          return Promise.all([
                            data.refetch(),
                            innerData.refetch(),
                          ])
                            .then(
                              () => {},
                              () => {}
                            )
                            .then(() => {
                              this.setState({ thinking: false });
                            });
                        });
                    };
                    if (
                      latestStripeInvoice.paymentIntentStatus === "succeeded"
                    ) {
                      return (
                        <P>
                          Your latest invoice for {amount} (dated {date}) was
                          paid ─ thanks for supporting PostGraphile! If need
                          additional information, don't hesitate to get in
                          touch.
                        </P>
                      );
                    } else if (
                      latestStripeInvoice.paymentIntentStatus ===
                      "requires_action"
                    ) {
                      return (
                        <div>
                          <P color={theme.color_danger}>
                            Your latest invoice (dated {date}) for {amount}{" "}
                            requires action, most likely as part of SCA in order
                            to prevent fraud. Click the button below to fix
                            this:
                          </P>
                          <P>
                            <SCAButton
                              secret={
                                latestStripeInvoice.paymentIntentClientSecret
                              }
                              onStart={handleStart}
                              onComplete={handleComplete}
                            >
                              Perform payment authorization
                            </SCAButton>{" "}
                          </P>
                        </div>
                      );
                    } else if (
                      latestStripeInvoice.paymentIntentStatus ===
                      "requires_payment_method"
                    ) {
                      return (
                        <div>
                          <P color={theme.color_danger}>
                            You don't have a valid payment method currently,
                            please address this:
                          </P>
                          <P>
                            <Button
                              element={Link}
                              to={`/settings/change-plan?plan=${encodeURIComponent(
                                innerData.data.viewer.latestPlan.nodes[0].planId
                              )}`}
                            >
                              Change payment settings
                            </Button>
                          </P>
                        </div>
                      );
                    } else {
                      return (
                        <P color={theme.color_danger}>
                          The latest invoice status is '
                          {latestStripeInvoice.paymentIntentStatus}' but we
                          don't have handling code for that... Please reach out
                          and let us know!
                        </P>
                      );
                      // return <p>{JSON.stringify(latestStripeInvoice)}</p>;
                    }
                  } else {
                    return (
                      <P>
                        <em>No recent invoices.</em>
                      </P>
                    );
                  }
                }}
              </Query>
            )}
          </RefreshStripeMutation>
          <Billing data={data} />
        </Box>
        <Box marginTop="lg">
          <H4>Link accounts</H4>
          <P>
            Use this section to link other accounts to your Graphile Store
            account. (NOTE: We don't currently indicate which services you've
            already linked, but logging in again will do no harm.)
          </P>
          <P>
            <Link href="/auth/github-sponsors">
              Log in with GitHub Sponsors
            </Link>{" "}
            ─ NOTE: full user and read organization access is required to
            determine sponsorship tier.
            <br />
            <Link href="/auth/github">Log in with GitHub</Link>
            <br />
            <Link href="/auth/patreon">Log in with Patreon</Link>
            <br />
          </P>
        </Box>
      </Box>
    );
  }
}
export default withTheme(SettingsPage);
